import {
  MAX_GRACE_PERIOD_MINUTES,
  MINUTES_IN_DAY,
  SLOT_MINUTES_VALUES,
  formatGraceLabel,
  formatTimeOfDay,
} from "./shiftHelpers";

const TIME_STEP_MINUTES = 15;

export const SHIFT_TIME_OPTIONS = Array.from(
  { length: MINUTES_IN_DAY / TIME_STEP_MINUTES },
  (_, index) => {
    const value = index * TIME_STEP_MINUTES;

    return { value, label: formatTimeOfDay(value) };
  },
);

export const SHIFT_GRACE_PERIOD_OPTIONS = [
  0,
  5,
  10,
  15,
  20,
  30,
  45,
  MAX_GRACE_PERIOD_MINUTES,
].map((value) => ({ value, label: formatGraceLabel(value) }));

export const SLOT_MINUTES_OPTIONS = SLOT_MINUTES_VALUES.map((value) => ({
  value,
  label: `${value} min`,
}));

export const DEFAULT_SHIFT = {
  name: "",
  description: "",
  startTime: 540,
  endTime: 1020,
  gracePeriodMinutes: 30,
  maxCollectPerSlot: 5,
  maxParkPerSlot: 3,
  slotMinutes: 15,
  isActive: true,
};
